import { useTranslation } from 'react-i18next';
import { Page } from '../../../components/Page/Page';
import { PimUserTable } from '../../../components/Users/Tables/PimUserTable';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const UsersPage = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()} title={t('routes.users.title')}>
      <PimUserTable />
    </Page>
  );
};
